export const numberOfBlanksForFillInBlankPrompt = (prompt) => {
  return prompt.match(/___/g)?.length || 0
}
